import { useTranslation } from "react-i18next";
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LogoWall from "./components/LogoWall";
import Diensten from "./components/Diensten";
import Realisaties from "./components/Realisaties";
import Subsidie from "./components/Subsidie";
import Wijken from "./components/Wijken";
import WaaromWij from "./components/WaaromWij";
import Reviews from "./components/Reviews";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";
import OfferteForm from "./components/OfferteForm";
import Footer from "./components/Footer";
import StickyMobile from "./components/StickyMobile";

function SchemaMarkup() {
  const { t } = useTranslation("home");
  const faqItems = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Ramen Repair Eindhoven",
    telephone: "+31407987470",
    email: "info@ramen-repair-eindhoven.nl",
    url: "https://ramen-repair-eindhoven.nl",
    image: "https://ramen-repair-eindhoven.nl/og-image.jpg",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Eindhoven",
      addressRegion: "Noord-Brabant",
      addressCountry: "NL",
      streetAddress: "Marconilaan 3",
      postalCode: "5612 HM",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "51.4416",
      longitude: "5.4697",
    },
    openingHours: "Mo-Su 00:00-23:59",
    priceRange: "€€",
    areaServed: ["Eindhoven", "Veldhoven", "Geldrop", "Nuenen", "Helmond", "Best", "Waalre", "Son en Breugel"],
    serviceType: [
      "Kozijnreparatie",
      "Raamreparatie",
      "Schuifpui reparatie",
      "Slot vervanging",
      "HR++ glas vervanging",
      "Velux dakraam reparatie",
    ],
  };

  const faqPage = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(localBusiness)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqPage)}
      </script>
    </>
  );
}

export default function Home() {
  return (
    <main className="bg-white min-h-screen">
      <title>Kozijn &amp; Raamreparatie Eindhoven | 48u Service</title>
      <meta name="description" content="Specialist in kozijn-, raam- en schuifpuireparatie in Eindhoven. PVC, aluminium, hout. Vanaf €75. Gratis offerte binnen 24 uur. Bel 040 798 7470." />
      <meta property="og:title" content="Kozijn &amp; Raamreparatie Eindhoven | 48u Service" />
      <meta property="og:description" content="Specialist in kozijn-, raam- en schuifpuireparatie in Eindhoven. PVC, alu, hout. Vanaf €75. Gratis offerte in 24u." />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=Professional%20craftsman%20hands%20working%20on%20modern%20window%20frame%20repair%20close-up%20tools%20yellow%20accents%20dark%20background%20editorial%20photography%20no%20faces%20sharp%20focus&width=1200&height=630&seq=ogimage2026&orientation=landscape" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Kozijn &amp; Raamreparatie Eindhoven | 48u Service" />
      <meta name="twitter:description" content="Specialist in kozijn-, raam- en schuifpuireparatie in Eindhoven. PVC, alu, hout. Vanaf €75. Gratis offerte in 24u." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=Professional%20craftsman%20hands%20working%20on%20modern%20window%20frame%20repair%20close-up%20tools%20yellow%20accents%20dark%20background%20editorial%20photography%20no%20faces%20sharp%20focus&width=1200&height=630&seq=ogimage2026&orientation=landscape" />
      <SchemaMarkup />
      <TopBar />
      <Header />
      <Hero />
      <LogoWall />
      <Diensten />
      <Realisaties />
      <Subsidie />
      <Wijken />
      <WaaromWij />
      <Reviews />
      <FAQ />
      <CTABanner />
      <OfferteForm />
      <Footer />
      <StickyMobile />
    </main>
  );
}